import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaMeta } from 'react-icons/fa6';

import SettingsOption, { OptionType } from '../SettingsOption';
import { useFormikContext } from 'formik';
import MetaPixelModal from './MetaPixelModal';

const MetaPixelSettings = () => {
  const { t } = useTranslation(['events']);
  const { values, setFieldValue } = useFormikContext<any>();
  const [showMetaPixelModal, setShowMetaPixelModal] = useState(false);

  const toggleMetaPixelModal = () => {
    setShowMetaPixelModal((showMetaPixelModal) => !showMetaPixelModal);
  };

  const onSave = (metaPixelId: string) => {
    setFieldValue('metaPixelId', metaPixelId);
  };

  return (
    <>
      <SettingsOption
        icon={<FaMeta size={20} />}
        title={t('events:settings.metaPixel.title')}
        actionLabel={t('events:settings.metaPixel.actionLabel')}
        onClick={toggleMetaPixelModal}
        value={values?.metaPixelId}
        type={OptionType.Button}
      />
      {showMetaPixelModal && (
        <MetaPixelModal
          onClose={toggleMetaPixelModal}
          onSave={onSave}
          initialValues={{
            metaPixelId: values?.metaPixelId || ''
          }}
        />
      )}
    </>
  );
};

export default MetaPixelSettings;
